//@flow
export default function getLocaleString(arg: number): string {
  const num = Number(arg);
  return num ? num.toLocaleString() : 'N/A';
}
